<template>
    <div class="w-100 mt-1">
        <div class="row between w-100 mb-1">
            <label for="" style="align-self: anchor-center;">Lista de productos a importar</label>
            <button type="button" class="btn-primary" @click="addProduct">Agregar producto +</button>
        </div>

        <span class="text-caption mt-1">
            En la siguiente lista configure los productos que desea importar con el servicio de {{ companyName }}
        </span>

        <div
            class="w-100 form-group mt-1"
            v-for="(product, index) in localProducts"
            :key="index"
        >
            <div class="row mb-1">
                <input
                    :name="`products[${index}]`"
                    type="text"
                    :class="['col custom-input-transparent', {'is-invalid': listErrors.includes(`product-${index}`)}]"
                    :placeholder="`${getPlaceholderByIndex(index)}`"
                    v-model="localProducts[index]"
                />

                <button type="button" class="btn-danger ml-1" @click="removeProduct(index)">
                    <i class="fa-solid fa-trash"></i>
                </button>
            </div>
        </div>
    </div>
</template>
  
<script>
export default {
    props: {
        products: Array,
        listErrors: Array,
        companyName: String
    },
    data() {
        return {
            localProducts: [],
        };
    },
    watch: {
        localProducts (newVal) {
            console.log('localProducts', newVal)
            this.$emit('update:products', newVal);
        },
    },
    methods: {
        addProduct() {
            this.localProducts.push('');
        },
        removeProduct(index) {
            this.localProducts.splice(index, 1);
        },
        getPlaceholderByIndex (index) {
            switch (index) {
                case 0:
                    return 'Ropa'
                case 1:
                    return 'Suplementos'
                default:
                    return `Producto ${index + 1}`
            }
        }
    },
    mounted() {
        console.log(this.products)
        this.localProducts = this.products
    }
}
</script>